// extracted by mini-css-extract-plugin
module.exports = {"attrib":"FullPerson-styles-module--attrib--1xWjH","image":"FullPerson-styles-module--image--2aR-2","text":"FullPerson-styles-module--text--1NvrV"};